import { useLayoutEffect } from 'react';
import { Platform } from 'react-native';
import { colors } from '../../shared/theme/colors';

/**
 * Mantiene el documento web alineado con el viewport de la app, normaliza el
 * focus visible y restaura los estilos previos al desmontar.
 */
export function useWebDocumentStyle(): void {
  useLayoutEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return;
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.backgroundColor;
    const prevBody = body.style.backgroundColor;
    const root = document.getElementById('root');
    let focusStyle = document.getElementById('vuelto-web-focus-styles');
    const createdFocusStyle = !focusStyle;
    if (!focusStyle) {
      focusStyle = document.createElement('style');
      focusStyle.id = 'vuelto-web-focus-styles';
      focusStyle.textContent = `
        *:focus { outline: none !important; }
        *:focus-visible {
          outline: 2px solid ${colors.accent} !important;
          outline-offset: 2px;
        }
        input:focus-visible,
        textarea:focus-visible,
        select:focus-visible {
          outline: none !important;
          box-shadow: 0 0 0 2px ${colors.accentSoft} !important;
        }
      `;
      document.head.appendChild(focusStyle);
    }
    html.style.backgroundColor = colors.background;
    body.style.backgroundColor = colors.background;
    html.style.height = '100%';
    body.style.height = '100%';
    html.style.minHeight = '100%';
    body.style.minHeight = '100%';
    if (root) {
      root.style.height = '100%';
      root.style.minHeight = '100%';
    }
    return () => {
      html.style.backgroundColor = prevHtml;
      body.style.backgroundColor = prevBody;
      html.style.height = '';
      body.style.height = '';
      html.style.minHeight = '';
      body.style.minHeight = '';
      if (root) {
        root.style.height = '';
        root.style.minHeight = '';
      }
      if (createdFocusStyle) focusStyle?.remove();
    };
  }, []);
}
